import * as yup from 'yup';

export const commonDiscountMappingValidation: { [x: string]: any; } = {
    billToCompanyCode: yup.string().required("Missing."),
    percentage: yup.string().required("Missing."),
    activeInd: yup.string().required("Missing."),
};

export const createDiscountMappingValidation: { [x: string]: any; } = {
    ...commonDiscountMappingValidation,
};

export const createDiscountMappingValidationSchema = yup.object().shape(createDiscountMappingValidation);

